import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {debugCNitoUrl} from '../../helpers';
import {loadLives} from '../../store/actions/lives';
import {selectLives} from '../../store/reducers';
import {
    mobileMediaQuery,
    tabletMediaQuery,
    tabletPortraitMediaQuery,
} from '../../styles';
import Loader from '../Loader';
import PurePlayer from '../PurePlayer';

const DKidsLivePlayer = () => {
    const dispatch = useDispatch();
    const lives = useSelector(selectLives);
    const [playerReady, setPlayerReady] = useState(false);

    useEffect(() => {
        if (!lives) {
            dispatch(loadLives());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!lives) {
        return <Loader />;
    }

    const onPlayerReady = () => {
        setPlayerReady(true);
    };

    return (
        <Container to={`/now/${lives[0].id}${debugCNitoUrl()}`}>
            <VideoPlayerContainer>
                <PurePlayer
                    content={{
                        id: lives[0].id,
                        src: lives[0].url,
                    }}
                    setPlayerReady={onPlayerReady}
                    setAdStarted={() => null}
                    muted
                    noAdvertising
                />
                <CoverImage opacity={playerReady ? 0 : 1} />
                <LiveIndicator />
            </VideoPlayerContainer>
        </Container>
    );
};

const Container = styled(Link)`
    display: flex;
    background-size: contain;
    width: 658px;
    height: 369px;
    left: 153px;
    top: 87px;
    cursor: pointer;
    border: 6px solid #ff5077;
    border-radius: 20px;
    filter: drop-shadow(20px 20px 40px rgba(0, 0, 0, 0.4));

    ${mobileMediaQuery} {
        width: 320px;
        height: 179px;
    }
    ${tabletPortraitMediaQuery} {
        width: 320px;
        height: 179px;
    }
    ${tabletMediaQuery} {
        width: 420px;
        height: 236px;
    }
`;

const VideoPlayerContainer = styled.span`
    position: relative;
    width: 100%;
    height: 100%;
    pointer-events: none;
    margin-top: 0px;
    margin-left: 0px;
    display: flex;
    align-items: center;
    overflow: hidden;

    #yui-wrapper {
        width: 100%;
        height: 100%;
        border-radius: 14px;
        z-index: 0;
    }
`;

const CoverImage = styled.img.attrs(() => ({
    src: require('../../assets/live_placeholder.png'),
}))`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    border-radius: 14px;
    transition: opacity 0.5s ease-in-out;
    opacity: ${props => props.opacity};
`;

const LiveIndicator = () => {
    let {t} = useTranslation();
    return (
        <LiveIndicatorContainer>
            <Dot />
            <LiveIndicatorText>{t('cartoonito.live.title')}</LiveIndicatorText>
        </LiveIndicatorContainer>
    );
};

const LiveIndicatorContainer = styled.div`
    position: absolute;
    top: -1px;
    align-self: baseline;
    background-color: #ff5077;
    border-radius: 20px;
    padding: 4px 10px 4px 10px;
    align-items: center;
    flex-direction: row;
    display: flex;
    left: 20px;
    top: 14px;
`;

const LiveIndicatorText = styled.span`
    font-family: Mont;
    font-weight: 900;
    font-size: 16px;
    color: white;
    text-transform: uppercase;
`;

const Dot = styled.div`
    width: 11px;
    height: 11px;
    background-color: white;
    border-radius: 5px;
    margin-right: 5px;

    ${mobileMediaQuery} {
        width: 7px;
        height: 7px;
    }
`;

export default DKidsLivePlayer;
